import React from "react";
import { ErrorMessage } from "formik";

type Props = {
  label?: string;
  required?: boolean;
  name?: string;
  yesOption?: string ;
  noOption?: string ;
  value: boolean;
  onChange: (value: boolean) => void;
};

const ATMSwitchButton = ({
  label,
  name,
  required = false,
  yesOption='YES',
  noOption ='NO',
  value,
  onChange,
}: Props) => {
  return (
    <div className="relative">
      {label && (
        <label className="text-slate-700 font-medium">
          {" "}
          {label} {required && <span className="text-red-500"> * </span>}{" "}
        </label>
      )}

      <div className={`${label && "mt-2"} h-[30px] flex items-center  rounded-md`}>
        <button
          type="button"
          onClick={() => onChange(!value)}
          className="flex justify-between min-w-[130px]  bg-slate-200 shadow rounded-md"
        >
          <div
            className={`${
              value ? "bg-primary-main text-white rounded shadow-lg" : "rounded-r"
            } flex-1 py-1 h-full transition-all duration-500`}
          >
            {yesOption}
          </div>
          <div
            className={`${
              !value ? " bg-primary-main text-white rounded shadow-lg" : "rounded-r"
            } flex-1 py-1 h-full transition-all duration-500`}
          >
          {noOption}
          </div>
        </button>
      </div>

      {name && (
        <ErrorMessage name={name}>
          {(errMsg) => (
            <p className="font-poppins absolute text-[14px] text-start mt-0 text-red-500">
              {" "}
              {errMsg}{" "}
            </p>
          )}
        </ErrorMessage>
      )}
    </div>
  );
};

export default ATMSwitchButton;
